'use strict'

import Axios, { AxiosInstance } from "axios";
import { CommonForm, CommonFormSecure, CommonFormParent, CommonFormFollowup211, CommonFormFeedbackFollowup, CommonFormReady4k } from '@/models/common-form';

export class CommonFormService {
  private _api!: AxiosInstance;

  constructor() {
    this._api = Axios.create({
      baseURL: process.env.VUE_APP_ECE_API_URL,
      responseType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': 'eaQSPYWOqAbDOpjX3zFC2bDJvh6z7wB3wV888d25'
      }
    });
  }

  async get(workflowId: string): Promise<CommonForm> {
    const response = await this._api.get<CommonForm>(`/CommonForm/${workflowId}`);
    return response.data;
  }

  async getSecure(token: string): Promise<CommonFormSecure> {
    const response = await this._api.get<CommonFormSecure>(`/CommonFormSecure/${token}`);
    return response.data;
  }

  async getParent(token: string): Promise<CommonFormParent> {
    const response = await this._api.get<CommonFormParent>(`/CommonFormParent/${token}`);
    return response.data;
  }

  async getFollowup211(token: string): Promise<CommonFormFollowup211> {
    const response = await this._api.get<CommonFormFollowup211>(`/CommonFormFollowup211/${token}`);
    return response.data;
  }

  async getFeedbackFollowup(token: string): Promise<CommonFormFeedbackFollowup> {
    const response = await this._api.get<CommonFormFeedbackFollowup>(`/CommonFormFeedbackFollowup/${token}`);
    return response.data;
  }

  async getReady4k(token: string): Promise<CommonFormReady4k> {
    const response = await this._api.get<CommonFormReady4k>(`/CommonFormReady4k/${token}`);
    return response.data;
  }

  async create(commonForm: CommonForm): Promise<CommonForm> {
    const response =  await this._api.post<CommonForm>('CommonForm', commonForm);
    return response.data;
  }

  async update(workflowId: string, commonForm: CommonForm): Promise<CommonForm> {
    const response =  await this._api.put<CommonForm>(`/CommonForm/${workflowId}`, commonForm)
    return response.data;
  }

  async startAndFinish(commonForm: CommonForm): Promise<CommonForm> {
    const response =  await this._api.post<CommonForm>('StartAndFinishCommonForm', commonForm);
    return response.data;
  }

  async getParentPDFBuffer(token: string): Promise<string> {
    const api = Axios.create({
      baseURL: process.env.VUE_APP_ECE_API_URL,
      responseType: 'text',
      headers: {
        'x-api-key': 'eaQSPYWOqAbDOpjX3zFC2bDJvh6z7wB3wV888d25'
      }
    });
    const response = await api.get(`/ParentPdf/${token}`)
    return response.data;
  }
}
